import { ICostSummaryItem, ILineItem } from '../CartContext.types';
import { useDevicePaymentHook } from './Device/DevicePaymentHook';
import { usePromoDiscountHook } from './Device/PromoDiscountHook';
import { useTradeInHook } from './Device/TradeInHook';

export const generateMonthlyDeviceCosts = (
    lineItem: ILineItem,
    summaryList: ICostSummaryItem[]
) => {
    summaryList.push(useDevicePaymentHook(lineItem, 'monthly'));

    const promoDiscount = usePromoDiscountHook(lineItem, 'monthly');
    if (promoDiscount) {
        summaryList.push(promoDiscount);
    }

    const tradeIn = useTradeInHook(lineItem, 'monthly');
    if (tradeIn) {
        summaryList.push(tradeIn);
    }
};
